<div class="home-container" [style.--cols]="columnsCount">
    <!-- <div class="val">haioiii</div> -->

    <div class="header-container py-3 px-9" [style.--cols]="columnsCount">
        <ng-container *ngFor="let category of categoryColums">
            <div class="col-1-header border-light-bottom">
                <img class="category-1-header icon-xl" [src]="categoryIcon[category]['img']" [style]="categoryIcon[category]['filter']">
                <h4 class="bold-text primary-text">{{category.charAt(0).toUpperCase() + category.slice(1)}}</h4>
            </div>
        </ng-container>
    </div>

    <div class="applist-container py-6 px-9">
        <ng-container *ngFor="let category of applist | keyvalue:originalOrder">
            <div class="col-1">
                <ng-container *ngFor="let module of category.value">
                    <div *ngIf="module.isSelectable || module.is_nonselected_menu_visible? true : false" class="module-chip px-3 radius-m module-chip-shadow" 
                        [ngClass]="module.isSelectable && module.catagory_order? ['module-active','category-'+module.catagory_order,'border-module-chip-'+module.catagory_order,'category-'+module.catagory_order+'-'+module.menucolor.color.replace('#','')] :'module-inactive'"
                        (click)="chip_click(module)">
                        <div class="module-chip-left"   [style]="module.menucolor?.filterColor">
                            <img class="icon-xl" [src]="module.img_url">
                        </div>
                        <div class="module-chip-right">
                            <label class=" content-l bold-text black-text">{{module.label}}</label>
                            <p class=" content-m primary-text">{{module.content}}</p>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <!-- <div class="col-1" (click)="logSearchClick()">Log Search</div> -->
    </div>



    <!-- <ng-container *ngFor="let category of applist | keyvalue:originalOrder">
        <div class="category-container">
            <div class="col-header">
                <img class="category-header" src="assets/menuicons/explore.svg">
                <h4>{{category.key}}</h4>
            </div>
            <div class="applist-container">
                <ng-container *ngFor="let module of category.value">
                    <div class="module-chip"
                        [ngClass]="module.isSelectable && module.catagory_order? ['module-active','category-'+module.catagory_order] :'module-inactive'"
                        (click)="chip_click(module)">
                        <div class="module-chip-left">
                            <img [src]="module.img_url">
                        </div>
                        <div class="module-chip-right">
                            <label class="header">{{module.label}}</label>
                            <p class="content">{{module.content}}</p>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

    </ng-container> -->


    <!-- <ng-continer *ngIf="applist.length==3">
        <div class="header-container">
            <div class="col-1-header">
                <img class="category-1-header" src="assets/menuicons/explore.svg">
                <h4>{{label[0]}}</h4>
            </div>
            <div class="col-2-header">
                <img class="category-2-header" src="assets/menuicons/manage.svg">
                <h4>{{label[1]}}</h4>
            </div>
            <div class="col-3-header">
                <img class="category-3-header" src="assets/menuicons/dashboard.svg">
                <h4>{{label[2]}}</h4>
            </div>
        </div>
        <div class="applist-container">
            <div class="col-1">
                <ng-container *ngFor="let module of applist[0]">
                    <div class="module-chip" [ngClass]="module.isSelectable && module.catagory_order? ['module-active','category-'+module.catagory_order] :'module-inactive'"
                        (click)="chip_click(module)">
                        <div class="module-chip-left">
                            <img [src]="module.img_url">
                        </div>
                        <div class="module-chip-right">
                            <label class="header">{{module.label}}</label>
                            <p class="content">{{module.content}}</p>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="col-2">
                <ng-container *ngFor="let module of applist[1]">
                    <div class="module-chip" [ngClass]="module.isSelectable && module.catagory_order? ['module-active','category-'+module.catagory_order] :'module-inactive'"
                        (click)="chip_click(module)">
                        <div class="module-chip-left">
                            <img [src]="module.img_url">
                        </div>
                        <div class="module-chip-right">
                            <label class="header">{{module.label}}</label>
                            <p class="content">{{module.content}}</p>
                        </div>
                    </div>
                </ng-container>
    
            </div>
            <div class="col-3">
                <ng-container *ngFor="let module of applist[2]">
                    <div class="module-chip" [ngClass]="module.isSelectable && module.catagory_order? ['module-active','category-'+module.catagory_order] :'module-inactive'">
                        <div class="module-chip-left">
                            <img [src]="module.img_url">
                        </div>
                        <div class="module-chip-right">
                            <label class="header">{{module.label}}</label>
                            <p class="content">{{module.content}}</p>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-continer>
    <ng-continer *ngIf="applist.length==1">
        <div class="general-applist-container">

            <ng-container *ngFor="let module of applist[0]">
                <ng-container *ngIf="module.isSelectable">
                    <div class="module-chip"
                        [ngClass]="module.isSelectable && module.catagory_order? ['module-active','category-'+module.catagory_order] :'module-inactive'"
                        (click)="chip_click(module)">
                        <div class="module-chip-left">
                            <img [src]="module.img_url">
                        </div>
                        <div class="module-chip-right">
                            <label class="header">{{module.label}}</label>
                            <p class="content">{{module.content}}</p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </ng-continer> -->


</div>